import * as tslib_1 from "tslib";
import { mobileDeviceFullStore } from '../store/store';
import { toggleDeviceLoggingWindow } from '../mutators/toggleDeviceLoggingWindow';
import { markIsDevicesDirty } from '../mutators/markIsDevicesDirty';
import { markIsNotSendReadReceiptDirty } from '../mutators/markIsNotSendReadReceiptDirty';
import { markIsLoggingEnabledDirty } from '../mutators/markIsLoggingEnabledDirty';
import { setCASMailbox } from '../services/setCASMailbox';
import { removeMobileDevice } from '../services/removeMobileDevice';
export function onSaveMobileOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var store, index, found, _i, _a, device;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    store = mobileDeviceFullStore();
                    if (!store.isLoggingEnabledDirty) return [3 /*break*/, 2];
                    return [4 /*yield*/, setCASMailbox(store.isLoggingEnabled)];
                case 1:
                    _b.sent();
                    toggleDeviceLoggingWindow();
                    markIsLoggingEnabledDirty(false);
                    return [3 /*break*/, 9];
                case 2:
                    if (!store.isNotSendReadReceiptDirty) return [3 /*break*/, 4];
                    return [4 /*yield*/, setCASMailbox(undefined, store.notSendReadReceipt)];
                case 3:
                    _b.sent();
                    markIsNotSendReadReceiptDirty(false);
                    return [3 /*break*/, 9];
                case 4:
                    if (!store.isDevicesDirty) return [3 /*break*/, 9];
                    index = 0;
                    _b.label = 5;
                case 5:
                    if (!(index < store.deviceStatistics.length)) return [3 /*break*/, 8];
                    found = false;
                    for (_i = 0, _a = store.devices; _i < _a.length; _i++) {
                        device = _a[_i];
                        if (store.deviceStatistics[index].Identity.RawIdentity ===
                            device.identity.RawIdentity) {
                            found = true;
                        }
                    }
                    if (!!found) return [3 /*break*/, 7];
                    return [4 /*yield*/, removeMobileDevice(store.deviceStatistics[index].Identity)];
                case 6:
                    _b.sent();
                    _b.label = 7;
                case 7:
                    index++;
                    return [3 /*break*/, 5];
                case 8:
                    markIsDevicesDirty(false);
                    _b.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=onSaveMobileOption.js.map